export const LANGUAGES = {
    JP: "jp",
    EN: "en"
}
